import * as React from 'react';

// #region Component Props

interface IProps {
    text        : string;
    onBtnClick  : any;
    icon?       : string;
    classes?    : string;
    id?         : string;
    disable?    : boolean;
    testID      : string;
}

// #endregion

const Button : React.SFC<IProps> = (props) => {

    const { icon, id, text, onBtnClick, classes, disable } = props;
    const hasIcon = icon ?  true : false;
    const classList = hasIcon ? 'btn new icon ' + classes : 'btn new ' + classes;

    return <button 
            id={ id }
            className={ classList }
            disabled={ disable }
            onClick={ onBtnClick } >
                { 
                    hasIcon ? 
                    <i className={'la ' + icon} /> :
                    ''
                }
                { text }
            </button>;
};

Button.defaultProps = {
    icon: '',
    classes: '',
    id: '',
    disable: false
};

export { Button };
